<template>
<div>
	<div class="panel panel-default" v-if="!isUpdate">
  		<ly-fixheader title="查看微信门店技师信息" btn="edit">
        	<div class="btn-group pull-right pr15" slot="s1">
				<a href="javascript:;" class="btn btn-block btn-primary pull-right" @click="setWeinxin"> 
				    <span v-if="info.is_wx == 0">
				    	<i class="glyphicon glyphicon-eye-open"></i>
						设为微信可见
					</span>
					<span v-else>
				    	<i class="glyphicon glyphicon-eye-close"></i>
						设为微信不可见
					</span>
				</a>
			</div>
		</ly-fixheader>
  		<div class="panel-body">
			<form class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-2 control-label">技师姓名:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.name}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">所在门店ID:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.shop_id}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">技师手机号:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.mechanic_phone}}</label>
					</div>
				</div>
			  	<div class="form-hr"></div>
				<div class="form-group">
					<label class="col-sm-2 control-label">认证信息:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.authentication}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">工种描述:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.profession}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">简介:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.introduction}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">擅长领域:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.good_at}}</label>
					</div>
				</div>
			  	<div class="form-hr"></div>
				<div class="form-group">
					<label class="col-sm-2 control-label">擅长车型品牌:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.good_at_brand}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">工作经验:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.experience}}</label>
					</div>
				</div>
			  	<div class="form-hr"></div>
				<div class="form-group" v-if="info.mechanic_img.length > 0">
					<label class="col-sm-2 control-label">技师照片:</label>
					<div class="col-sm-10">
						<img class="imgsize" v-for="item in info.mechanic_img" track-by="$index" src="{{item}}">
					</div>
				</div>
			</form>
		</div>
  	</div>
  	<ly-mechanicupdate v-if="isUpdate" :info="info"></ly-mechanicupdate>
</div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var Common = require('../utils/Common.js');
	var info = {};//公司详情
	module.exports = {
		data : function(){
			return {
				isUpdate : false,
				info : {}
			}
		},
		components : {
			'ly-mechanicupdate' : require('./mechanic_add.vue'),
			'ly-fixheader' : require('../components/Fixheader.vue')
		},
		ready : function () {
			var self = this;
			var mid = this.$route.params['mid'];//获得技师的ID
			Http['mechanic'].query({
				key : [mid],
				succ : function(rs){
					rs['id'] = mid;
					self.$set('info',rs);
				}
			});
		},
		methods : {
			/**
			* 设为微信可见/不可见
			*/
			setWeinxin: function(){
				var mid = this.$route.params['mid'];//获得技师的ID
				var self = this;
				if(this.info.is_wx == 1) {
					Common.confirm('确定要设为微信不可见吗?', function(){
						Http['mechanic'].delete({
							key: [mid, 1],
							succ: function(rs){
								self.info.is_wx = 0;
								Common.tipDialog('成功设为微信不可见',1500,'success');
							},
							err: function(rs){
								Common.tipDialog(rs,1500,'error');
							}
						});
					});	
				} else if(this.info.is_wx == 0) {
					Common.confirm("确定要设为微信可见吗?",function(){
						Http['mechanic'].createStatus({
							key : [mid],
							succ : function(rs){
								self.info.is_wx = 1;
								Common.tipDialog("成功设为微信可见!",1500,"success");
							},
							err : function(rs) {
								Common.tipDialog(rs,1500,"success");
							}
						});
					});
				}
			}
		},
		events : {
			doUpdate : function(){
				this.isUpdate = true;
			},
			closeUpdate : function(){
				this.isUpdate = false;
			},
			goback : function(){
				Common.go('mechanic_list');
			}
		}
	};
</script>


/** WEBPACK FOOTER **
 ** mechanic_info.vue?84fe060e
 **/